<template>
  <div class="wrapper">
    <div class="wrapper-body">
      <!-- <img src="https://img-test.chinabeego.com/uploadfile/2022/11/1/1667290902295457445039068472.png" alt /> -->
      <img v-for="item in formData.mainPic" :key="item" :src="item" alt />

      <div class="header-card">
        <div class="title">
          {{formData.name}}
        </div>
        <div class="integral-count">
          <div class="integral" v-if="formData.receiveValue != 0"><span class="max-font">{{formData.receiveValue}}</span>积分</div>
          <div class="count">剩余：{{formData.total || 0}} 张</div>
        </div>
      </div>
      <div class="date-card">
        <span class="label">有效期</span>
        <span class="date">{{formData.receivableBeginTime}}&ensp;至&ensp;{{formData.receivableEndTime}}</span>
      </div>

      <!-- <img src="https://img-test.chinabeego.com/uploadfile/2022/11/1/1667290902295457445039068472.png" alt /> -->
      <img v-for="item in formData.couponDetailPics" :key="item" :src="item" alt />
    </div>


    <div class="footer">
      <button class="button" @click="btnClick">立即{{formData.receiveValue == 0 ? '领取' : '兑换'}} </button>
    </div>

    <van-action-sheet v-model="show">
      <div class="sheet-content">
        <div class="coupon-box">
          <div class="details">
            <div class="icon-bg">
              <span>优惠券</span>
              <img src="../../../assets/unionpay/count-bg.png" alt />
            </div>

            <div class="limit">
              <div class="money"><span class="max-font">{{formData.couponValue}}</span>元</div>
              <div class="dtl">满 {{formData.minimumAmount}} 元可用</div>
            </div>
            <div class="title-date">
              <div class="title">
                {{formData.name}}
              </div>
              <div class="footer-date">
                <div class="date">{{formData.receivableBeginTime.split(' ')[0]}} 至 {{formData.receivableEndTime.split(' ')[0]}}</div>
                
                <div class="integral"><span class="max-font">{{formData.receiveValue}}</span>
                {{formData.receiveMethod == 1 ? '积分' : '元'}}</div>
              </div>
            </div>
          </div>
          <div class="coupon-type">
            <div>全场通用</div>
            <div>商品类型：全部商品</div>
          </div>
        </div>

        <div class="coupon-number">
          <div class="integral">积分余额：{{formData.integral || 0}}</div>
          <div class="coupon-num">
            <div class="label">兑换数量</div>
            <van-stepper v-model="count" max="999" class="stepper"/>
          </div>
        </div>
      </div>
      <div class="footer">
        <button class="button" @click="gotoExchange">立即兑换</button>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import http from "@/utils/axios";
export default {
  components: {},
  props: {},
  data() {
    return {
      show: false,
      count:1,
      formData:{
        mainPic:[],
        couponDetailPics:[],
        receivableBeginTime:"",
        receivableEndTime:""
      }
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$loading.hide();
    this.getForm()
  },
  mounted() {
  },
  methods: {
    getForm(){
      http({
        url: `/order/ysf/coupon/${this.$route.query.couponId}`,
        method: "get"
      }).then(res => {
        if (res.code === 200 && res.data) {
          // console.log(res.data);
          // res.data.receiveValue = 0
          res.data.mainPic = res.data.mainPic || []
          res.data.couponDetailPics = res.data.couponDetailPics || []
          res.data.integral = JSON.parse(sessionStorage.getItem("userInfo") || "{}").integral;
          this.formData = res.data
        }
      });
    },
    gotoExchange(){
      this.$router.push({
        path: '/unionpayCouponOrder',
        query:{
          id:this.$route.query.couponId,
          integralAmt: this.formData.integral || 0,
          count: this.count
        }
      })
    },
    btnClick(){
      if(this.formData.receiveValue == 0){
        // console.log('领取');
        this.$router.push({
          path: '/unionpayOrder',
          query:{
            id:this.$route.query.couponId,
            integralAmt: this.formData.integral || 0,
            count: this.count
          }
        })
      }else{
        this.show = true
      }
    }
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  font-size: 24px;
  color: #333;
  overflow: hidden;
  .wrapper-body{
    height: calc(100vh - (110px + constant(safe-area-inset-bottom)));
    height: calc(100vh - (110px + env(safe-area-inset-bottom)));
    overflow: auto;
  }
  .header-card {
    margin-top: -8px;
    padding: 20px 30px;
    background: #fff;
    .title {
      font-size: 28px;
      font-weight: 600;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .integral-count {
      display: flex;
      align-items: baseline;
      line-height: 67px;
      .integral {
        color: #ed3939;
        flex: 1;
        .max-font {
          font-size: 48px;
          font-weight: 600;
          margin-right: 10px;
        }
      }
      .count {
        color: #999;
        font-weight: 400;
      }
    }
  }
  .date-card {
    padding: 30px;
    margin: 10px 0;
    background: #fff;
    .label {
      margin-right: 90px;
    }
    .date {
      color: #999;
    }
  }
  .footer {
    position: fixed;
    left: 0;
    bottom:0;
    width: 100%;
    z-index: 999;
    text-align: center;
    background: #fff;
    padding: 10px 0;
    padding-bottom: calc(10px + constant(safe-area-inset-bottom));
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
    .button {
      width: 690px;
      height: 80px;
      background: linear-gradient(90deg, #ff8200 0%, #ff1414 100%);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 40px;
      border: none;
      color: #fff;
    }
  }
  .sheet-content {
    padding: 47px 30px 10px 30px;
    .coupon-box{
      border: 1px solid #eeeeee;
      border-radius: 8px;
    }
    .details {
      height: 164px;
      display: flex;
      align-items: center;
      position: relative;
      border-bottom: 1px solid #eeeeee;
      border-radius: 8px 8px 0 8px;
      .icon-bg {
        width: 82px;
        height: 36px;
        position: absolute;
        top: 0;
        color: #fff;
        span {
          font-size: 20px;
          position: absolute;
          left: 11px;
          top: 4px;
        }
      }
      .limit {
        width: 260px;
        height: 100%;
        color: #e15554;
        text-align: center;
        background: #feeaeb;
        border-radius: 8px 0px 36px 8px;
        .money {
          margin-top: 26px;
          .max-font{
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            font-size: 64px;
            margin-right: 8px;
          }
        }
        .dtl {
          font-size: 20px;
        }
      }
      .title-date {
        flex: 1;
        padding: 0 30px 0 24px;
        .title {
          width: 376px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #3b3a38;
          line-height: 33px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .footer-date {
          font-size: 20px;
          display: flex;
          align-items: baseline;
          margin-top: 18px;
          .date {
            flex: 1;
            color: #ccc;
          }
          .integral{
            font-weight: 600;
            color: #ED3939;
            .max-font{
              font-size: 36px;
            }
          }
        }
      }
    }
    .coupon-type{
      color: #999;
      line-height: 50px;
      padding: 20px 30px;
    }
    .coupon-number{
      padding: 20px 0 20px 30px;
      margin-bottom: 258px;
      .integral{
        color: #F8A651;
        line-height: 40px;
        margin-bottom: 20px;
      }
      .coupon-num{
        display: flex;
        align-items: center;
        .label{
          color: #999;
          flex: 1;
        }
      }
    }
  }
}
</style>